import { cn } from '@/lib/utils';
import { semanticTokens } from '@packages/config/theme';
import { useTranslation } from 'react-i18next';

/**
 * FooterLocaleSwitcher - Language selector for footer
 * 
 * Format: English · Español · Português · Русский
 * Uses semantic tokens for consistent styling
 */
export function FooterLocaleSwitcher() {
  const { i18n } = useTranslation('common');
  const set = (lng: 'en' | 'es' | 'pt' | 'ru') => i18n.changeLanguage(lng);
  const currentLang = i18n.language;

  const languages = [
    { code: 'en' as const, label: 'English' },
    { code: 'es' as const, label: 'Español' },
    { code: 'pt' as const, label: 'Português' },
    { code: 'ru' as const, label: 'Русский' },
  ];

  return (
    <div className={cn(
      "flex gap-2 items-center",
      semanticTokens.typography.bodySmall,
      "flex-wrap"
    )}>
      {languages.map((lang, index) => (
        <span key={lang.code} className="flex items-center gap-2">
          {index > 0 && (
            <span className={cn(semanticTokens.fg.muted)} aria-hidden="true">
              ·
            </span>
          )}
          <button
            onClick={() => set(lang.code)}
            className={cn(
              "underline",
              "hover:text-foreground",
              semanticTokens.motion.standard,
              "transition-colors",
              semanticTokens.focus.ring,
              "rounded-sm",
              currentLang === lang.code
                ? cn("font-medium", semanticTokens.accent.fg)
                : semanticTokens.fg.muted
            )}
            aria-label={`Switch to ${lang.label}`}
            aria-current={currentLang === lang.code ? 'true' : undefined}
          >
            {lang.label}
          </button>
        </span>
      ))}
    </div>
  );
}
